import React from 'react'
import { Alert, Col, Container, ProgressBar, Row } from 'react-bootstrap'
import CloseIcon from '../../images/icons/close_panel.svg'

interface UploadModalProps {
	percentageComplete: number
	message: string
	onClose: () => void
}

const LoadingModal = (props: UploadModalProps) => {
	return (
		<div className={'estimate-modal'}>
			<Container>
				<Row className="pb-3">
					<Col onClick={() => props.onClose()} className="panel-close-btn" sm="auto">
						<img src={CloseIcon} alt="Close" className="pr-2" />
						<span className="span-bold span-navy span-body-2">Close</span>
					</Col>
				</Row>
				{props.percentageComplete < 100 && (
					<Row className="pb-3">
						<Col>
							<ProgressBar animated now={props.percentageComplete} />
						</Col>
					</Row>
				)}
				<Row>
					<Col>
						<Alert variant="info">{props.message}</Alert>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

export default LoadingModal
